import { Navigate, Route, Routes } from "react-router-dom"

import BackofficeIndex from "./index";
import BackofficeLayout from "./BackofficeLayout";
import Consultants from "./consultants";
import FailuresPage from "./failures";
import StepsPage from "./steps";

const BackofficeRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<BackofficeIndex {...props} />} />
    <Route path="/consultants" element={
      <BackofficeLayout>
        <Consultants {...props} />
      </BackofficeLayout>
    } />
    <Route path="/failures" element={
      <BackofficeLayout>
        <FailuresPage {...props} />
      </BackofficeLayout>
    } />
    <Route path="/steps" element={
      <BackofficeLayout>
        <StepsPage {...props} />
      </BackofficeLayout>
    } />
  </Routes>
);

export default BackofficeRoutes;    